import React from 'react';
import logo from './content/images/coming-soon.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="logo" />
        <p>
          Coming soon...
        </p>
      </header>
    </div>
  );
}

export default App;
